import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { v4 as uuidv4 } from 'uuid';
import { keyBy } from 'lodash-es';
import { firstBy } from 'thenby';

import { reportError } from 'lib/error-reporting';
import * as api from 'lib/api';
import * as jobsApis from 'lib/api/jobs';
import { findApplicableRateCards, fetchMatchingCostCentre } from 'lib/helpers-metadata';
import { convertFromUtcToTimezone } from 'lib/helpers-time';
import { isFeatureOn } from 'lib/features';

import { shiftFieldMappings } from 'config/shiftFieldMappings';
import { featureFlags } from 'config/featureFlags';

import {
  addShiftsToList,
} from 'reducers/jobs';

import {
  isApprovingShifts,
  approveShiftsSuccess,
  approveShiftsError,
  clearApproveShiftsError,
  validationError,
} from 'reducers/approveShifts';

import {
  upsertRecentlyActiveShifts,
} from 'reducers/createShifts';

import * as jobsActions from 'reducers/jobs';

export function approveShifts(shiftKeys) {
  return async (dispatch, getState) => {

    try {
      dispatch(isApprovingShifts());
      const response = await jobsApis.approveShifts(shiftKeys);
      if (response.success && response.shiftSummaries) {
        dispatch(addShiftsToList(response.shiftSummaries));
        dispatch(jobsActions.unselectAllShifts());
        const recentlyApprovedShifts = {};
        Object.values(response.shiftSummaries).forEach((shift) => {

          recentlyApprovedShifts[shift.key] = {
            ...shift,
            booked: shift.booked ?? (shift.candidate ? 1 : 0),
            shiftNumber: shift.shiftNumber,
            candidateName: shift.candidateName ?? (shift.candidates ? Object.values(shift.candidates)[0] : null),
            isCreated: true,
            key: shift.key,
            isValid: shift.isValid,
          };
        });
        dispatch(upsertRecentlyActiveShifts(recentlyApprovedShifts));
        dispatch(approveShiftsSuccess());
      }
    } catch (error) {
      // If unexpected error, save to Redux
      reportError(error);
      dispatch(approveShiftsError(error.message));
    }
  };
}
